import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute, notFound, useParams } from '@tanstack/react-router';

import { projectDetailsQueryOptions } from '@/app/queries/projects';
import { NavBreadcrumb } from '@/common/components/features/nav-breadcrumb';
import { AbilityProvider } from '@/common/components/features/role-management';
import {
  ProjectError,
  ProjectLoader,
  ProjectNotFound,
} from '@/common/components/templates/project-page';
import { ensureNotFound } from '@/infra/network/query';

function RouteComponent() {
  const { projeto: project } = useParams({ from: '/_app/_dashboard/projetos/$projeto' });

  const { data } = useSuspenseQuery(projectDetailsQueryOptions(project));

  if (!data) {
    throw notFound();
  }

  return (
    <AbilityProvider role={data.role.id}>
      <NavBreadcrumb />
      <Outlet />
    </AbilityProvider>
  );
}

export const Route = createFileRoute('/_app/_dashboard/projetos/$projeto')({
  component: RouteComponent,
  loader: ({ params, context }) =>
    ensureNotFound(context.queryClient.ensureQueryData(projectDetailsQueryOptions(params.projeto))),
  pendingComponent: () => (
    <>
      <NavBreadcrumb />
      <ProjectLoader />
    </>
  ),
  errorComponent: () => (
    <>
      <NavBreadcrumb />
      <ProjectError />
    </>
  ),
  notFoundComponent: () => (
    <>
      <NavBreadcrumb />
      <ProjectNotFound />
    </>
  ),
  staleTime: Infinity,
  head: ({ match }) => ({
    meta: [
      {
        title: `${match.loaderData?.name} | Podcast AI`,
      },
    ],
  }),
});
